// util to check if we are on nextjs via presence of 'next/image'
const isNextJS = () => {
    let result = false;
    try {
        require.resolve('next/image');
        result = true;
    }
    catch (e) {
        // do nothing
    }
    return result;
};
/**
 *
 * This function takes a date string in the format `yyyy-mm-dd` and a locale string,
 * then returns the date formatted as `MMMM dd, yyyy`, where `MMMM` is the full month name,
 * `dd` is the day of the month, and `yyyy` is the four-digit year.
 *
 * @param {string} dateString - The date string to format, in the format `yyyy-mm-dd`.
 * @param {string} locale - The locale string used to format the date (e.g., 'en-US', 'fr-FR').
 * @returns {string} The formatted date string in the format `MMMM dd, yyyy`.
 *
 * @example
 * // Returns "August 29, 2024" if the locale is 'en-US'
 * monthDateFormating('2024-08-29', 'en-US');
 *
 * @example
 * // Returns "29 août 2024" if the locale is 'fr-FR'
 * monthDateFormating('2024-08-29', 'fr-FR');
 */
function monthDateFormating(dateString, locale) {
    // Create the Date object
    const date = new Date(dateString);
    // Format the date using Intl.DateTimeFormat
    return new Intl.DateTimeFormat(locale, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }).format(date);
}
/**
 * This function aims to provide a DateTime format string (ie: dd-mm-yyyy) base on provided locale
 *
 * @param {string} locale - The locale string used to format the date
 * @param {Intl.DateTimeFormatOptions} options - optional
 * @returns {string} DateTime format string
 */
function getDatetimeFormatFromLocale(locale, options) {
    const getPatternForPart = (part) => {
        switch (part.type) {
            case 'day':
                return 'd'.repeat(part.value.length);
            case 'month':
                return 'M'.repeat(part.value.length);
            case 'year':
                return 'y'.repeat(part.value.length);
            case 'literal':
                return part.value;
        }
    };
    return new Intl.DateTimeFormat(locale, options).formatToParts(new Date())
        .map(getPatternForPart)
        .join('');
}
/**
 * Checks if the user's device is a mobile or tablet.
 *
 * This function examines the user agent string to determine if the device
 * is classified as mobile (e.g., Android phones, iPhones) or tablet (e.g.,
 * iPads, Android tablets) using regular expressions. It returns true if
 * either condition is met, and false otherwise.
 *
 * @returns {boolean} - True if the device is mobile or tablet; otherwise, false.
 *
 * @example
 * if (isMobileOrTabDevice()) {
 *   console.log('Mobile or tablet device');
 * }
 */
function isMobileOrTabDevice() {
    const isMobileDevice = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|webOS|BlackBerry/i.test(navigator.userAgent);
    const isTabletDevice = /iPad|tablet|Android(?!.*Mobile)/i.test(navigator.userAgent);
    return isMobileDevice || isTabletDevice;
}

export { getDatetimeFormatFromLocale, isMobileOrTabDevice, isNextJS, monthDateFormating };
//# sourceMappingURL=utils.js.map
